import * as Yup from "yup";

export const udenlandskAdvokatsamfundForm: FormConfig<PersonUdenlandskAdvokatsamfundDTO> =
  {
    title: "EU",
    validationSchema: Yup.object({
      navn: Yup.string().required("Udenlandsk advokatsamfund være sat"),
      crossBorderIndDato: Yup.date()
        .nullable()
        .required("Startdato skal være sat"),
      crossBorderUdDato: Yup.date()
        .nullable()
        .when(
          "crossBorderIndDato",
          (crossBorderIndDato, yup) =>
            crossBorderIndDato &&
            yup.min(crossBorderIndDato, "Slutdato kan ikke være før startdato"),
        ),
    }),
    form: [
      {
        component: "textinput",
        id: "navn",
        label: "Udenlandsk advokatsamfund",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "crossBorderIndDato",
        label: "Startdato",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "crossBorderUdDato",
        label: "Slutdato",
        initialValue: "",
      },
    ],
    get: "",
  };
